export { DateOfBirth } from './date-of-birth.component';
